import React from "react";
import { CheckCircle2, Calendar } from "lucide-react";

const STRATEGY_CALL_URL = process.env.REACT_APP_STRATEGY_CALL_URL || "https://lunacal.ai/don-stevens-64r/meeting";

export const ReportCampaigns = ({ strategy }) => {
  const campaigns = strategy.campaign_ideas || [];
  return (
    <div className="space-y-6">
      {campaigns.length === 0 ? (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8 text-center">
          <p className="text-slate-400">Campaign ideas will appear here once generated.</p>
        </div>
      ) : (
        campaigns.map((campaign, i) => (
          <div key={`campaign-${campaign.campaign_name}-${i}`} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6 hover:border-emerald-500/30 transition-colors">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-xl flex items-center justify-center text-white font-bold">
                {i + 1}
              </div>
              <div>
                <h3 className="font-bold text-white text-lg">{campaign.campaign_name}</h3>
                <p className="text-emerald-400 text-sm">{campaign.target_audience}</p>
              </div>
            </div>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-medium text-slate-400">Objective</p>
                <p className="text-slate-300">{campaign.objective}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-slate-400">Key Message</p>
                <p className="text-slate-300">{campaign.key_message}</p>
              </div>
              {campaign.channels && (
                <div>
                  <p className="text-sm font-medium text-slate-400 mb-2">Channels</p>
                  <div className="flex flex-wrap gap-2">
                    {campaign.channels.map((ch) => (
                      <span key={`campch-${ch}`} className="px-3 py-1 bg-slate-800 text-slate-300 rounded-full text-sm">{ch}</span>
                    ))}
                  </div>
                </div>
              )}
              {campaign.tactics && (
                <div>
                  <p className="text-sm font-medium text-slate-400 mb-2">Tactics</p>
                  <ul className="space-y-1">
                    {campaign.tactics.map((tactic) => (
                      <li key={`camptac-${tactic.slice(0, 30)}`} className="text-slate-300 text-sm flex items-start gap-2">
                        <CheckCircle2 className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" /> {tactic}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ))
      )}

      <div className="mt-10 bg-gradient-to-br from-emerald-900/40 to-emerald-800/20 border-2 border-emerald-500/40 rounded-2xl p-8 text-center" data-testid="strategy-call-cta">
        <h3 className="text-2xl font-bold text-white mb-3">Ready to Bring These Ideas to Life?</h3>
        <p className="text-slate-300 mb-6 max-w-xl mx-auto">
          This report is your roadmap — let our team help you execute it. Book a free strategy call to discuss how we can turn these campaigns into real results for your business.
        </p>
        <a
          href={STRATEGY_CALL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-lg rounded-xl transition-colors shadow-lg shadow-emerald-500/25"
          data-testid="book-strategy-call-btn"
        >
          <Calendar className="w-5 h-5" />
          Book a Strategy Call
        </a>
        <p className="text-slate-500 text-sm mt-4">Free 30-minute consultation · No obligation</p>
      </div>
    </div>
  );
};
